import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    back: false,
    stops: false,
    token: null,
    isAuthenticated: false,
    user: false,
    device: {
      info: false,
      languageCode: false
    }
  },
  mutations: {
    SET_BACK_BUTTON (state, url) {
      state.back = url
    },
    SET_STOPS (state, stops) {
      state.stops = stops
    },
    SET_DEVICE_INFO (state, info) {
      state.device.info = info
    },
    SET_DEVICE_LANGUAGE (state, languageCode) {
      state.device.languageCode = languageCode
    },
    SET_TOKEN (state, token) {
      state.token = token
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
      window.localStorage.setItem('token_pontveer', token)
    },
    REVOKE_TOKEN(state) {
      state.token = null
      state.isAuthenticated = false
      state.user = null
      axios.defaults.headers.common['Authorization'] = ''
      window.localStorage.removeItem('token_pontveer')
    },
    SET_AUTHENTICATED(state) {
      state.isAuthenticated = true
    },
    SET_USER(state, user) {
      state.user = user
    }
  },
  actions: {
    toggleFavorite (context, payload) {
      if (!payload.isFavorite) {
        axios.post(`${process.env.VUE_APP_API_URL}/auth/me/favorites/${payload.lineID}`)
        .then(response => {
          context.commit('SET_USER', response.data)
        })
      } else {
        axios.delete(`${process.env.VUE_APP_API_URL}/auth/me/favorites/${payload.lineID}`)
        .then(response => {
          context.commit('SET_USER', response.data)
        })
      }
    }
  }
})

// test() {
//   if (!this.isFavorite) {
//     axios.post(`${process.env.VUE_APP_API_URL}/auth/me/favorites/${this.lineId}`)
//     .then(response => {

//     })
//   } else {
//     axios.delete(`${process.env.VUE_APP_API_URL}/auth/me/favorites/${this.lineId}`)
//     .then(response => {

//     })
//   }
// }
